<template>
  <v-navigation-drawer mobile-breakpoint="0" class="queues-agents-panel" touchless
    v-model="show" fixed app right clipped :width="350">
    <v-card v-if="queue" class="full-height-card">
      <div class="flex-grow">
        <v-card-title>
          <span class="agents-main-title text-truncate">{{ queue.name }}</span>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="hide" v-on="on" small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('queues.tooltip.hide') }}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider/>
        <v-list three-line>
          <v-tabs fixed-tabs v-model="activeTab">
            <v-tab>
              <v-icon class="mr-2">mdi-account-group</v-icon>
              <v-badge :content="agentsOnCall" :value="agentsOnCall">
                {{ $t('queues.agentsTitle') }} ({{ queue.agents.length }})
              </v-badge>
            </v-tab>
            <v-tab>
              <v-icon class="mr-2">mdi-phone-incoming</v-icon>
              <v-badge :content="calls" :value="calls">
                {{ $t('queues.callsTitle') }}
              </v-badge>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <v-list three-line>
                <template v-for="(agent, idx) in queue.agents">
                  <QueueAgent :agent="agent" :queue-name="queue.id" :key="`${idx}-agent`"/>
                </template>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-container v-if="calls === 0" class="no-active-calls">
                <v-icon color="orange">mdi-information-outline</v-icon>
                {{ $t('queues.calls.noCalls') }}
              </v-container>
              <v-list three-line subheader>
                <template v-for="(call, idx) in queue.calls">
                  <QueueCall :call="call" :key="`${idx}-call`" :ts-now="tsNow" />
                </template>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-list>
      </div>
      <v-divider/>
      <v-card-actions v-if="activeTab === 0">
        <v-spacer/>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="green" icon @click="unpauseAllPrompt=true" v-on="on" small :disabled="!canAllPause">
              <v-icon>mdi-play</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('queues.tooltip.allUnpause') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="pauseAllPrompt=true" v-on="on" small :disabled="!canAllPause">
              <v-icon color="orange">mdi-pause</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('queues.tooltip.allPause') }}</span>
        </v-tooltip>
        <v-spacer/>
      </v-card-actions>
    </v-card>
    <PauseConfirm :show="pauseAllPrompt"
      title="pauseAll" title-icon="pause"
      title-icon-color="orange"
      v-if="queue"
      :agents="queue.agents"
      @set-pause="allAgentsPause(1, $event)"
      @cancel="pauseAllPrompt=false" />

    <PauseConfirm :show="unpauseAllPrompt"
      title="unpauseAll" title-icon="play"
      title-icon-color="green"
      v-if="queue"
      :agents="queue.agents"
      @set-pause="allAgentsPause(0, $event)"
      @cancel="unpauseAllPrompt=false" />

  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QueueAgent from './agent'
import QueueCall from './call'
import PauseConfirm from './pause_confirm'
import * as RMQClient from '@/rmqclient'

export default {
  name: 'queue-agents',
  data () {
    return {
      tsNow: 0,
      activeTab: 0,
      pauseAllPrompt: false,
      unpauseAllPrompt: false
    }
  },
  computed: {
    ...mapGetters({
      canAgentPause: 'permissions/canQAgentPause',
      agentsPaneShow: 'queues/agentsPaneShow',
      queue: 'queues/active'
    }),
    show: {
      get: function () {
        return this.agentsPaneShow
      },
      set: function (val) {
        this.setPaneShow(val)
      }
    },
    agentsOnCall: function () {
      return this.queue.agents.reduce((i, a) => i + a.calls.length, 0)
    },
    calls: function () {
      return this.queue.calls?.length ?? 0
    },
    canAllPause: function () {
      return this.queue.agents.some(a => this.canAgentPause(a.subscriberId))
    }
  },
  timer: 'queueCallTSNow',
  components: { QueueAgent, QueueCall, PauseConfirm },
  methods: {
    ...mapActions({
      setPaneShow: 'queues/showAgentsPane',
      setActive: 'queues/setActive'
    }),
    queueCallTSNow: function () {
      this.tsNow = Date.now()
    },
    hide: function () {
      this.show = false
      this.setActive(null)
    },
    allAgentsPause: function (paused, reason) {
      this.pauseAllPrompt = this.unpauseAllPrompt = false
      this.queue.agents.forEach((a) => {
        if (this.canAgentPause(a.subscriberId)) {
          RMQClient.sendCmd({
            action: 'QueuePause',
            interface: a.interface,
            paused: paused,
            queue: this.queue.id,
            reason: reason
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.full-height-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex: 1;
}
</style>
